const Credits = (props) => {
    return <div style={{
        color: "white",
        fontWeight: "bold",
        padding: ".5em"
    }}>
        Created by Jonny and Matthias{props.showTutorialLink ? <span> | <a href="/tutorial" style={{ color: "white" }}>How to play</a></span> : <div/>}
    </div>

}

export default Credits;